import React from "react";
import {
  PhotoIcon,
  SpeakerWaveIcon,
  VideoCameraIcon,
  FilmIcon,
  ArchiveBoxIcon,
  MusicalNoteIcon,
  LightBulbIcon,
  UserPlusIcon,
} from "@heroicons/react/24/outline";
import { TFunction } from "i18next";

export interface MenuItem {
  key: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  type?: never;
}

export interface MenuDivider {
  type: "divider";
  key?: never;
  label?: never;
  icon?: never;
}

export type MenuItemType = MenuItem | MenuDivider;

export const appConfig = {
  name: "FancyPeter AI Studio ",
  description: "AI驱动的智能视频创作平台",
  icon: {
    gradient: "from-indigo-500 to-purple-600",
  },
};

export const menuItems: MenuItemType[] = [
  {
    key: "projects",
    icon: FilmIcon,
    label: "剧集",
  },
  {
    key: "creative-chat",
    icon: LightBulbIcon,
    label: "创意",
  },
  { type: "divider" },
  {
    key: "image-generation",
    icon: PhotoIcon,
    label: "图片",
  },
  {
    key: "audio-generation",
    icon: SpeakerWaveIcon,
    label: "音频",
  },
  {
    key: "music-generation",
    icon: MusicalNoteIcon,
    label: "音乐",
  },
  {
    key: "video-generation",
    icon: VideoCameraIcon,
    label: "视频",
  },
  { type: "divider" },
  {
    key: "subject-library",
    icon: ArchiveBoxIcon,
    label: "主体库",
  },
];

/** 返回带翻译的菜单项，在组件中调用 */
export function getMenuItems(t: TFunction): MenuItemType[] {
  return [
    {
      key: "projects",
      icon: FilmIcon,
      label: t("nav:projects"),
    },
    {
      key: "creative-chat",
      icon: LightBulbIcon,
      label: t("nav:creativeChat"),
    },
    { type: "divider" },
    {
      key: "image-generation",
      icon: PhotoIcon,
      label: t("nav:imageGeneration"),
    },
    {
      key: "audio-generation",
      icon: SpeakerWaveIcon,
      label: t("nav:audioGeneration"),
    },
    {
      key: "music-generation",
      icon: MusicalNoteIcon,
      label: t("nav:musicGeneration"),
    },
    {
      key: "video-generation",
      icon: VideoCameraIcon,
      label: t("nav:videoGeneration"),
    },
    {
      key: "avatar-training",
      icon: UserPlusIcon,
      label: t("nav:avatarTraining"),
    },
    { type: "divider" },
    {
      key: "subject-library",
      icon: ArchiveBoxIcon,
      label: t("nav:subjectLibrary"),
    },

  ];
}
